import createVueApp from '@/common/createApp'

Styxie.Initializers.LindaGoogleOauthCallbacks = {
  success: async(props) => {
    const { default: CallbackSuccess } = await import('@/vue_widgets/linda/google_oauth_callbacks/success/index.vue')
    createVueApp(CallbackSuccess, { props, layout: null })
  },
  failure: async(props) => {
    const { default: CallbackFailure } = await import('@/vue_widgets/linda/google_oauth_callbacks/failure/index.vue')
    createVueApp(CallbackFailure, { props, layout: null })
  }
}
